import { LoginMethod, loginMethod } from "@songtradr-sso/shared/common";
import { Flex } from "@songtradr-sso/shared/frontend";
import { Heading } from "@songtradr/design-language";
import { useAuthContext } from "../../layouts/App.Parts";
import { Props, text } from "./AuthButtons.Parts";
import { EmailPasswordButton } from "./email-password/EmailPasswordButton";
import { GoogleButton } from "./google/GoogleButton";
import { UpstreamButton } from "./upstream/Upstream";

export const AuthButtons = ({ onEmailButtonClick }: Props) => {
  const { workspace, loginMethods, upstreamProviders } = useAuthContext();

  const renderButtons = () => {
    // Default buttons...
    if (!workspace) {
      return (
        <>
          <EmailPasswordButton onClick={onEmailButtonClick} />
          <GoogleButton />
        </>
      );
    }

    if (!loginMethods?.length) return <div>{text.noMethods}</div>;
    return loginMethods.map((method: LoginMethod) => {
      if (method === loginMethod.Enum.EMAIL_PASSWORD)
        return (
          <EmailPasswordButton key={method} onClick={onEmailButtonClick} />
        );

      if (method === loginMethod.Enum.GOOGLE)
        return <GoogleButton key={method} />;

      if (method === loginMethod.Enum.UPSTREAM) {
        return upstreamProviders?.map((provider) => (
          <UpstreamButton key={provider.id} provider={provider} />
        ));
      }

      return null;
    });
  };

  return (
    <Flex $flow="column">
      <Heading variant="section">{text.title}</Heading>
      {renderButtons()}
    </Flex>
  );
};
